<template>
  <div class="chart">
    <div v-for="item in data" :key="item.key" class="bar">
      <div class="bar_" :style="getBarStyle(item)">
        <div class="value-label">
          {{item.value}}
        </div>
      </div>
      <div class="label">{{item.label}}</div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Array,
      validator: (items) => items.every(object => object.key && object.value && object.label)
    }
  },
  methods: {
    getBarStyle(item) {
      const { value, colour } = item;
      const values = this.data.map(item => item.value);
      const max = Math.max.apply(null,values);

      return `height:${value / max * 200}px;background-color:${colour}`;
    }
  }
}
</script>

<style scoped>

.chart {
  display: flex;
  justify-content: space-between;
  align-items: baseline;

  margin-top: 25px;
}

.bar {
  width: 100%;
  margin: 0 2px;
  max-width: 200px;
}

.bar_ {
  position: relative;
  border-radius: 10px;
}

.value-label {
  position: absolute;
  top: -25px;
  width: 100%;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/Chart.vue